export default function LossReport() {
  return (
    <div className="erp-page-grid">
      <h2>Loss Report</h2>
    </div>
  );
}